module.exports = __webpack_public_path__ + "fonts/MessinaSansWeb-Black.9044cb07.eot";